module.exports = __webpack_public_path__ + "static/media/transport.9345e9d3.avif";